import React from 'react'

import { Portlet, Form, Row, Col } from '_zari/core'

import * as Formatos from './formatos'

const TIPOSREPORTE = {
  LISTAASIENTOSDESCUADRADOS: '1'
}

const ReporteConsistencias = () => {
  const [tipoReporte, setTipoReporte] = React.useState(TIPOSREPORTE.LISTAASIENTOSDESCUADRADOS)

  return (
    <Portlet>
      <Portlet.Header title='Consistencias' />
      <Portlet.Body>
        <Row>
          <Col md={3}>
            <Form.Radio
              id='radio-listaAsientosDescuadrados'
              name='tipoReporte'
              label='LISTA DE ASIENTOS DESCUADRADOS'
              value={TIPOSREPORTE.LISTAASIENTOSDESCUADRADOS}
              checked={tipoReporte === TIPOSREPORTE.LISTAASIENTOSDESCUADRADOS}
              onChange={() => setTipoReporte(TIPOSREPORTE.LISTAASIENTOSDESCUADRADOS)}
            />
          </Col>
          <Col md={9} style={{ borderLeft: '1px solid black' }}>
            {tipoReporte === TIPOSREPORTE.LISTAASIENTOSDESCUADRADOS && <Formatos.FormatoListaAsientosDescuadrados />}
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteConsistencias)
